import { yupResolver } from "@hookform/resolvers/yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { PaleteEnum } from "../../../interfaces/Enums";
import { useAuthCreate } from "../../../queries/Auth/create";
import { useGlobalLoading } from "../../../store/GlobalLoading";
import { useSignUp } from "../../../store/SignUp";
import { ICompleteFormData, IFormData, formSchema } from "./validation";

export default function Complete() {
  const [showPassword, setShowPassword] = useState(false);
  const { openLoading } = useGlobalLoading();
  const {
    signUpState: { email },
    clearSignUpState,
  } = useSignUp();
  const { createUser } = useAuthCreate();

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<ICompleteFormData>({
    resolver: yupResolver(formSchema),
  });

  const onSubmit = (data: ICompleteFormData) => {
    const bodySubmit: IFormData = {
      email: email,
      name: data.name,
      password: data.password,
    };

    openLoading();
    createUser(bodySubmit);
  };

  return (
    <Grid container flexDirection={"column"} p={4}>
      <Typography variant="h5" textAlign={"center"} fontWeight={"bold"} mb={4}>
        Crie sua conta
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container mb={1} rowGap={1}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <>
                <TextField
                  {...field}
                  value={field.value || ""}
                  variant="outlined"
                  placeholder="Nome"
                  label="Nome"
                  error={!!errors["name"]}
                  fullWidth
                />
                <Typography variant="caption" mt={0.5} color={"red"}>
                  {errors.name?.message}
                </Typography>
              </>
            )}
          />
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <>
                <TextField
                  {...field}
                  value={field.value || ""}
                  variant="outlined"
                  placeholder="Senha"
                  label="Senha"
                  type={showPassword ? "text" : "password"}
                  error={!!errors["password"]}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          onMouseDown={(e) => e.preventDefault()}
                          edge="end"
                        >
                          {!showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography variant="caption" mt={0.5} color={"red"}>
                  {errors.password?.message}
                </Typography>
              </>
            )}
          />
          <Controller
            name="confirmPassword"
            control={control}
            render={({ field }) => (
              <>
                <TextField
                  {...field}
                  value={field.value || ""}
                  variant="outlined"
                  placeholder="Confirme sua senha"
                  label="Confirme sua senha"
                  type={showPassword ? "text" : "password"}
                  error={!!errors["confirmPassword"]}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          onMouseDown={(e) => e.preventDefault()}
                          edge="end"
                        >
                          {!showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography variant="caption" mt={0.5} color={"red"}>
                  {errors.confirmPassword?.message}
                </Typography>
              </>
            )}
          />
        </Grid>
        <Grid item container flexDirection={"column"} rowSpacing={1}>
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              sx={{
                bgcolor: PaleteEnum.bluePrimary,
                "&:hover": {
                  bgcolor: PaleteEnum.bluePrimary,
                },
              }}
              fullWidth
            >
              Crie sua conta
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={clearSignUpState}
              sx={{ color: PaleteEnum.bluePrimary }}
              fullWidth
            >
              Voltar
            </Button>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
}
